import React, { useState } from 'react';
import {
  Autocomplete,
  TextField,
  Chip,
  FormHelperText
} from '@mui/material';

import classNames from 'classnames';
import { makeStyles } from '@mui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/customInputStyle.js';

const useStyles = makeStyles(styles);


export default function ChipTextField(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helperText,
    ...rest
  } = props;

  const [values, setValues] = useState(() => {
    if (inputProps && inputProps.value) {
      return inputProps.value.replace(",", " ").split(' ').filter(Boolean);
    }
    return [];
  });

  const [inputValue, setInputValue] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);

  const handleChange = (event, newValue) => {
    if (editingIndex !== null) {
      const newlyAdded = newValue.filter(
        (item) => !values.includes(item)
      );

      if (newlyAdded.length > 0) {
        let expandedNewValues = [];
        newlyAdded.forEach(item => {
          const splitValues = item.split(',').map(v => v.trim()).filter(Boolean);
          expandedNewValues.push(...splitValues);
        });

        let arr = newValue.filter(item => !newlyAdded.includes(item));

        let insertPos = editingIndex;
        for (const item of expandedNewValues) {
          arr.splice(insertPos, 0, item);
          insertPos++;
        }

        newValue = arr;
      }

      setEditingIndex(null);
    } else {
      const lastValue = newValue[newValue.length - 1];
      if (lastValue && lastValue.includes(',')) {
        newValue.pop();
        const splitValues = lastValue.split(',').map(v => v.trim()).filter(Boolean);
        newValue.push(...splitValues);
      }
    }

    setValues(newValue);

    if (inputProps && typeof inputProps.onChange === 'function') {
      inputProps.onChange({
        target: { value: newValue.join(' ') },
      });
    }
  };

  const handleInputChange = (event, newInput) => {
    setInputValue(newInput);
  };

  const handleEditChip = (chipToEdit, index) => {
    let newValues = [...values];
    newValues.splice(index, 1);
    setValues(newValues);
    setEditingIndex(index);
    setInputValue(chipToEdit);
  };

  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error,
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });
  const helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });

  const formControlClasses = classNames(
    formControlProps && formControlProps.className,
    classes.formControl
  );

  return (
    <div className={formControlClasses} {...(formControlProps || {})}>
      <Autocomplete
        multiple
        freeSolo
        options={[]}
        value={values}
        onChange={handleChange}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        renderTags={(tagValues, getTagProps) =>
          tagValues.map((option, index) => {
            const tagProps = getTagProps({ index });
            return (
              <Chip
                key={option}
                label={option}
                variant="outlined"
                size="small"
                onClick={() => handleEditChip(option, index)}
                {...tagProps}
              />
            );
          })
        }
        renderInput={(params) => (
          <>
            <TextField
              {...params}
              variant="standard"
              id={id}
              label={labelText}
              InputLabelProps={{
                ...params.InputLabelProps,
                shrink: true,
                className: classNames(classes.labelRoot, labelClasses),
                style: {
                  position: 'relative',
                  backgroundColor: '#fff',
                  zIndex: 2,
                  padding: '0 4px',
                  transform: 'translate(0, -8px) scale(0.75)',
                  ...labelProps?.style
                },
                ...labelProps,
              }}
              margin="none"
              classes={{
                root: marginTop,
              }}
              InputProps={{
                ...params.InputProps,
                classes: {
                  input: inputClasses,
                  underline: underlineClasses,
                  disabled: classes.disabled,
                },
              }}
              {...rest}
            />
            {helperText && (
              <FormHelperText id={id + '-text'} className={helpTextClasses}>
                {helperText}
              </FormHelperText>
            )}
          </>
        )}
      />
    </div>
  );
}
